import { gql } from "@apollo/client"
import { LOGIN_FIELDS } from "./queryLogin"

const queryRefreshToken = async (client) => {
  try {
    const response = await client.query({
      query: gql`
        ${LOGIN_FIELDS}
        query Refresh {
          refresh {
            ...LoginFields
          }
        }
      `,
      fetchPolicy: "network-only",
    })
    return response
  } catch (err) {
    return err
  }
}

export { queryRefreshToken }
